import { Button, Icon, Typography, VerticalDivider } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Card, LinearProgressBar, Section } from '@hero/atoms';
import { ChartDescription } from '@hero/components/organisms/Recognition';
import { AUTOMATIONS_TAB } from '@hero/constants';
import { DetailItem } from '@hero/molecules';
import { formatPercentage, getAnalyticRates } from '@hero/utils/helper';

import * as S from './style';

function AutomationThankYouNotes({ analytics, setActiveTab }) {
  const { t } = useTranslation();
  const appreciationPercentage = formatPercentage(analytics?.appreciationRates?.rate * 100, 1);
  const rate = getAnalyticRates(analytics?.acceptanceRates, { format: true });

  return (
    <Card style={{ gap: 16, flex: 1 }}>
      <S.CardHeader>
        <Typography variant="body1Bold">{t('tyNotes')}</Typography>
        <VerticalDivider />
        <Button
          variant="link"
          startIcon={<Icon name="preview" />}
          onClick={() => setActiveTab(AUTOMATIONS_TAB.thankYou)}
        >
          {t('viewList')}
        </Button>
      </S.CardHeader>
      <Section style={{ border: '1px solid var(--color-accent-secondary-weaker)' }}>
        <DetailItem
          bodyStyle={{
            display: 'flex',
            alignItems: 'center'
          }}
          title={`${t('tyNoteRate')}:`}
        >
          <S.BarArea>
            <LinearProgressBar
              backgroundColor="var(--color-warning-weaker)"
              visualParts={[
                {
                  percentage: appreciationPercentage,
                  color: 'var(--color-warning-default)'
                }
              ]}
            />
            <S.Rate>{appreciationPercentage}</S.Rate>
          </S.BarArea>
        </DetailItem>
        <S.Row>
          <ChartDescription
            title={t('notesReceived')}
            total={analytics?.acceptanceRates?.total}
            current={analytics?.acceptanceRates?.opened}
            percent={rate.opened}
            color="var(--color-warning-strong)"
          />
          <ChartDescription
            title={t('notesUnreceived')}
            total={analytics?.acceptanceRates?.total}
            current={analytics?.acceptanceRates?.total - analytics?.acceptanceRates?.opened}
            percent={rate.unopened}
            color="var(--color-warning-weaker)"
          />
        </S.Row>
      </Section>
    </Card>
  );
}

export { AutomationThankYouNotes };
